import type { JSX } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { CheckoutPage } from './pages/CheckoutPage';
import { TossSuccessPage } from './pages/TossSuccessPage';
import { TossFailPage } from './pages/TossFailPage';
import { SuccessPage } from './pages/SuccessPage';
import { CancelPage } from './pages/CancelPage';
import { ExpiredPage } from './pages/ExpiredPage';
import { ErrorPage } from './pages/ErrorPage';

/**
 * Hosted checkout page router.
 *
 * The hosted checkout URL emitted by the server's mock provider
 * (and future real Stripe/Toss adapters) is of the form:
 *
 *     http://localhost:4100/checkout/{sessionId}?token=...
 *
 * The end user lands on that URL, the CheckoutPage component reads
 * the sessionId from the route param and the token from the query
 * string, fetches the public session view, and renders the CO-01
 * screen from docs/en/05-uiux-design.md §2.4. Success, Cancel,
 * Expired, and Error screens are the other states in the flow.
 *
 * Phase 0 scope: the checkout page has a single "Pay (mock)"
 * button that calls /mock-complete and transitions the user to
 * Success. Real payment provider redirect flows replace this in
 * Stage 6 (Stripe) and Stage 7 (Toss).
 */
export function App(): JSX.Element {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/checkout/:sessionId" element={<CheckoutPage />} />
        <Route path="/toss/success" element={<TossSuccessPage />} />
        <Route path="/toss/fail" element={<TossFailPage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/cancel" element={<CancelPage />} />
        <Route path="/expired" element={<ExpiredPage />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="*" element={<Navigate to="/error" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
